import { Container, ContainerItem } from '../common/container/Container'
import { PatientProps } from '../modules/patient/container'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import { PATIENT_API_KEY, PATIENT_SERVICE_KEY, PATIENT_MODULE } from '../modules/patient'
import { PatientService } from '../modules/patient/services/PatientService'
import { PatientApi } from '../modules/patient/api/PatientApi'

let container: Container

function init(p: PatientProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(PATIENT_API_KEY, new ContainerItem({ instance: new PatientApi() }))
  items.set(
    PATIENT_SERVICE_KEY,
    new ContainerItem({
      instance: new PatientService({ apiKey: PATIENT_API_KEY }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getPatientContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[PATIENT_MODULE],
      },
    })
  }

  return container
}
